import {
  Body3,
  Box,
  Display,
  FlexDirection,
  FontFamily,
  Heading6,
  Image,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import React from 'react'
import type { CuratedBoxRecipePreviewLineItemProps } from '../../../types/curatedBoxTypes'

export const CuratedBoxRecipePreviewLineItem = ({
  title,
  prepTimes,
  recipeImageSrc,
  recipeId,
  handleRecipe,
  curatedBoxCollectionId,
}: CuratedBoxRecipePreviewLineItemProps) => {
  const onClick = () => {
    handleRecipe(recipeId, curatedBoxCollectionId)
  }

  const keyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleRecipe(recipeId, curatedBoxCollectionId)
    }
  }

  return (
    <Box
      role="button"
      onKeyDown={keyDown}
      tabIndex={0}
      onClick={onClick}
      data-testid="curatedBoxPreviewLineItem"
      paddingBottom={2}
    >
      <Box paddingH={2} display={Display.Flex} flexDirection={FlexDirection.Row}>
        <Box paddingH={2}>
          <Image fit="cover" height="64px" width="116px" alt={recipeId} src={recipeImageSrc} />
        </Box>
        <Box
          paddingH={0.5}
          paddingV={0.5}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          justifyContent={JustifyContent.SpaceBetween}
        >
          <Heading6 size={1} fontFamily={FontFamily.Bold}>
            {title}
          </Heading6>
          <Body3>{prepTimes} mins</Body3>
        </Box>
      </Box>
    </Box>
  )
}
